import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import { getAllowedActions, setAllowedActions } from '../store/actions';
import { AllowedAction } from 'api';

export const useAuthorization = (userActions?: AllowedAction[]) => {
	const dispatch = useDispatch();
	const allowedActions = useSelector((store: RootState) => store.Login.allowedActions) || [];
	const isLoading = useSelector((store: RootState) => store.Login.loading) || false;

	useEffect(() => {
		if (userActions) {
			dispatch(setAllowedActions(userActions));
		} else if (!userActions && allowedActions.length === 0) {
			dispatch(getAllowedActions());
		}
	}, [userActions]); // eslint-disable-line react-hooks/exhaustive-deps

	function hasAllowedAction(allowedAction: AllowedAction): boolean {
		return allowedActions.includes(allowedAction);
	}

	return {
		allowedActions,
		hasAllowedAction,
		isLoading
	};
};
